import { Collection, MultilineInput, TextInput } from "@tblabs/truffle";
import { CollectionItemPrinter } from "../../Utils/CollectionItemPrinter";
import { Faq } from "../../../Models/Description/Faq/Faq";


export class FaqEntryEditor extends CollectionItemPrinter<Faq>
{
    constructor(faq: Faq, faqs: Collection<Faq>)
    {
        super(faq, faqs);

        this.Append(
            new TextInput(faq.Question).Placeholder("Pytanie").WidthPercent(85),
            new MultilineInput(faq.Answer).Rows(3).Placeholder("Odpowiedź").WidthPercent(85).MarginTop(4),
        )
    }
}
